import template from './notAvailable.html';

export function NotAvailableViewModel(params) {
}

// The default export returns the component details object to register with KO
export default { viewModel: NotAvailableViewModel, template: template };

